import React from 'react';

class InstructionMessage extends React.Component {
  render() {
    if(this.props.messageFor === 'nivel'){
      return(
        <>
          <div className="messageClassNivel">
            {/* <i style={{ marginTop: '3px' }} class="fas fa-lightbulb-on"></i> */}
            <img src='/imgs/light-bulb.png' style={{maxHeight:"35px"}} />
            <p style={{ marginLeft: '15px' }}>{this.props.message}</p>
          </div>
        </>
      )
    }else{
      return (
        <>
          <div className="messageClass">
            <span style={{ marginTop: '3px' }} className="k-icon k-i-information" />
            <p style={{ marginLeft: '15px' }}>{this.props.message}</p>
          </div>
        </>
      );
    }
  }
}

export default InstructionMessage;
